import { FetchNextPageOptions, InfiniteData, InfiniteQueryObserverResult } from "@tanstack/react-query";
import { ImageBody } from "../api";
import { Button } from "@/shared/ui/button.tsx";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import { GalleryPreviewContext, GalleryPreviewContextType } from "../context";
import { useContext, useEffect } from "react";
import ImageSelection from "./ImageSelection";
import ImagePreview from "./ImagePreview";

type Props<T> = {
  galleryImages?: ImageBody[];
  hasNextPage:boolean,
  fetchNextPage: (
    options?: FetchNextPageOptions
  ) => Promise<
    InfiniteQueryObserverResult<InfiniteData<{ data: T[] }, unknown>, Error>
  >;
};

const ImageGrid = <T,>({ galleryImages, fetchNextPage, hasNextPage }: Props<T>) => {

  const theme = useAtomValue(themeAtom)

  const { openPreview, setImages } = useContext<GalleryPreviewContextType>(GalleryPreviewContext)

  useEffect(() => {
    setImages(galleryImages ? galleryImages : [])
  }, [galleryImages, setImages])

  return (
    <div className="size-full">
      {galleryImages && <p className="text-sm text-gray-500 font-poppins py-3">{galleryImages.length} Images found</p>}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {galleryImages?.map((image) => (
          <ImageSelection
            key={image.id}
            image={image} />
        ))}
      </div>
      <div className="w-full py-6 flex items-center justify-center">
        {hasNextPage &&
          <Button
            className="rounded-full"
            onClick={() => fetchNextPage()}
            style={{
              backgroundColor: theme.secondary
            }}>View More
          </Button>
        }
        {!hasNextPage && galleryImages && <p className="text-sm font-montserrat tracking-wide" >No more images in this catalogue</p>}
      </div>
      {openPreview && <ImagePreview />}
    </div>
  )
}

export default ImageGrid;
